(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltManagementController', OltManagementController);

    OltManagementController.$inject = ['$scope', 'OltService', 'OltData'];

    function OltManagementController($scope, OltService, OltData) {

        var vm = this;

        vm.data = OltData;
        var oltList = null;
        var names = '';
        var arrayNames = [];
        vm.arrayIds = [];

        vm.loadItems = function () {
            oltList = vm.data.selected;
            arrayNames = [];
            vm.arrayIds = [];

            oltList.forEach(function (olt) {
                arrayNames.push(olt.name);
                vm.arrayIds.push(olt.id);
            });
            names = arrayNames.join(', ');
            vm.oltData = {
                amount: vm.data.selected.length,
                names: names
            };
            toggleMessage(oltList);

        }
        $scope.$on('oltItemSelectedLoad', vm.loadItems);

        // Public Methods
        vm.delete = function () {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOlts',
                methodExtra: function (oltList, oltErrorList) {
                    if (oltErrorList) {
                        // Remove onus with error on delete from selected list
                        oltErrorList.forEach(function (oltError) {
                            oltList.forEach(function (selectedOlt, index, array) {
                                if (oltError.id == selectedOlt.id) {
                                    array.splice(index, 1);
                                }
                            });
                        });
                    }

                    // Remove deleted onus from onu list
                    OltData.removeOlts(oltList);
                }
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.restart = function () {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOlts'
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.backup = function () {
            var dataAction = {
                action: 'backup',
                methodService: 'backupOlts'
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.initialize = function () {
            vm.loadItems();
        }
        vm.initialize();

        // Private Methods
        function toggleMessage(oltList) {
            if (oltList.length == 1) {
                vm.itemOne = true;
            } else {
                vm.itemOne = false;
            }
        }
    }
})();
